import dynamic from 'next/dynamic'
import { Marker } from 'react-mapbox-gl'
import IconMapMarker from '@icons/Marker'
import * as S from './SimpleMap.styled'

const Map = dynamic(() => import('@global/Map/Mapbox'), {
  ssr: false,
})

const SimpleMap = ({ coordinates, visibleLayers }) => {
  return (
    <S.MapWrap>
      <Map center={coordinates} visibleLayers={visibleLayers} zoom={[13]}>
        <Marker key='location' anchor='bottom' coordinates={coordinates}>
          <IconMapMarker style={{ position: 'relative', bottom: -14 }} />
        </Marker>
      </Map>
    </S.MapWrap>
  )
}

export default SimpleMap
